import type { LoaderFunctionArgs } from 'react-router-dom'
import { getPreparationContainers } from 'client/stock-transfers/stock-transfers.client'
import { mockData } from './mock'

export const preparationLoader = async ({
  params,
  request
}: LoaderFunctionArgs) => {
  const url = new URL(request.url)
  const useMockData = url.searchParams.get('mockData')

  if (useMockData) {
    return mockData
  }
  return await getPreparationContainers(params.transferId!)
}
